import { graphql } from 'relay-runtime';

export const CartFragment = graphql`
  fragment shopCartFragment on Cart
  @argumentDefinitions(channel: { type: "CartChannel!" }) {
    id
    cartId
    accountNumber
    isAccountNumberRequired
    segment
    shippableItems {
      offerId
      categories
    }
    bundles {
      lineNumber
      isLineNumberRequired
      bundleId
      bundleType
      bundleSubType
      processContext
      categoryId
      promotion
      offerIds
      availability {
        available
        offerCategory
        status
      }
      items {
        action
        itemId
        productOfferingId
        title
        creditItemDescriptions
        description
        priceItemName
        priceItemDescriptions
        quantity
        removable
        editable
        dealText
        imageUrl
        totalPrice
        balanceManagement
        action
        contractTerm {
          name
          value
          unit
          ifpOfferId
        }
        preOrderable
        prices {
          billingFrequency
          frequencyType
          basePrice {
            value
            taxExclusiveValue
          }
          effectivePrice {
            value
            taxExclusiveValue
          }
          discount {
            discountId
            type
            value
            discountType
            value
            taxExclusiveValue
            discountText
            discountAppliedValue
          }
        }
        offerId
        categories
        dataLayerCategory
        balanceManagement
        isIncluded
        shouldHide
        promotion
      }
    }
    auth {
      isAuthenticated
      isGuest
    }
    summaries {
      billingFrequency
      frequencyType
      subtotal
      total
      taxExclusiveSubtotal
      discount
      taxExclusiveDiscount
      taxExclusiveTotal
      gst
    }
    mpdDiscountPercentage
    productOfferImages(channel: $channel) {
      offerId
      url
      type
    }
  }
`;
